"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validateUrlUnreserved = /[a-z\u0400-\u04FF0-9\-._~]/i;
exports.default = validateUrlUnreserved;
module.exports = exports["default"];